var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { createRef } from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/checkbox/checkbox.scss';
export const Checkbox = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const _ref = createRef();
    const fireEvent = () => {
        _ref.current.click();
    };
    const wrapperStyles = cn({
        [styles.checkbox]: true,
        [className]: className
    });
    return (React.createElement("div", { className: wrapperStyles },
        React.createElement("input", Object.assign({ type: "checkbox" }, props)),
        React.createElement("span", { className: styles.circle, onClick: fireEvent }),
        React.createElement("label", { ref: _ref, className: styles.text, htmlFor: props.id }, children)));
};
